import CodeCard from "./CodeCard";
import { Col, Row } from "react-bootstrap";
const CodesList = (props) => {
  const codes = props.codes;
  const store = props.store;
  return (
    <Row className="my-5">
      {/* <Col lg={12} className="text-right">
        <h3>أكواد الخصم:</h3>
      </Col> */}
      <Col lg={12}>
        {codes && codes.map((c) => <CodeCard code={c} store={store} key={c.id} />)}
      </Col>
    </Row>
  );
};

export default CodesList;
